import React from "react";
import { Link } from "react-router-dom";
import firebase from "firebase";

import iconAlert from "../assets/img/IconeAlerta.png";

const Header = (props) => {
  var user = firebase.auth().currentUser;
  return (
    <nav className="navbar-dark pt-2 pb-2 mb-3 cinza">
      <div className="container">
        <div className="row">
          <div className="col-7 col-md-6">
            <Link className="navbar-brand" to={user ? "/dashboard" : "/"}>
              <img src={iconAlert} width="35" height="35" alt="" /> Alerta Celular
            </Link>
          </div>
          <div className="col-5 col-md-6 text-right">
            <Link className="navbar-brand duvidas" to="/duvidas">
              Dúvidas
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
};
export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.js